"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegalNavListItem = exports.StyledLegaContentWrapper = exports.StyledLegalNav = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLegalNav = styled_components_1.default.ul.withConfig({ displayName: "StyledLegalNav", componentId: "sc-rd0ded" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.x3};
  margin: ${(props) => props.theme.spacers.x4} 0 ${(props) => props.theme.spacers.x8};
  list-style: none;
  padding: 0;
  justify-content: flex-end;
`;
exports.StyledLegaContentWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledLegaContentWrapper", componentId: "sc-1dv10yo" }) `
  padding-bottom: ${(props) => props.theme.spacers.x12};

  p {
    ${(props) => props.theme.responsiveTypography.body.medium}
    margin-bottom: ${(props) => props.theme.spacers.x4};
  }

  li {
    ${(props) => props.theme.responsiveTypography.body.medium}
  }

  strong {
    font-weight: ${(props) => props.theme.fontWeights.semiBold};
  }

  h3 {
    ${(props) => props.theme.responsiveTypography.heading.large}
    font-weight: ${(props) => props.theme.fontWeights.semiBold};
  }

  h4 {
    ${(props) => props.theme.responsiveTypography.heading.medium}
    font-weight: ${(props) => props.theme.fontWeights.semiBold};
  }

  a {
    color: ${(props) => props.theme.colors.celticBlue};
    text-decoration: none;
  }

  table {
    border-spacing: 0;
    margin: 0 0 ${(props) => props.theme.spacers.x3};
  }

  th {
    font-weight: 600;
  }

  th,
  td {
    font-size: ${(props) => props.theme.typography.x2.fontSize};
    border-bottom: 1px solid ${(props) => props.theme.body.textColor};
    padding: ${(props) => props.theme.spacers.x1} ${(props) => props.theme.spacers.x2};
  }

  tbody tr:last-child td {
    border: none;
  }
`;
exports.StyledLegalNavListItem = styled_components_1.default.li.withConfig({ displayName: "StyledLegalNavListItem", componentId: "sc-j4dz9x" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}

  a {
    color: ${(props) => (props.isActive ? props.theme.colors.celticBlue : props.theme.colors.oxfordBlue)};
    text-decoration: none;

    &:hover {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }
`;
